export const UPDATE_AMOUNT_TILLAGG = 'UPDATE_AMOUNT_TILLAGG';
export const GET_LOCAL_TILLAGG = 'GET_LOCAL_TILLAGG';
export const UPDATE_CHECKED = 'UPDATE_CHECKED';
export const GET_LOCAL_TILLAGGFORM = 'GET_LOCAL_TILLAGGFORM';
export const UPDATE_CHECKED_BANDEROLL = 'UPDATE_CHECKED_BANDEROLL';
export const UPDATE_ARTICLE = 'UPDATE_ARTICLE';


export const updateAmount = (data, index) => {

    return {
        type: UPDATE_AMOUNT_TILLAGG,
        data: data,
        index: index
    }

}

export const getLocalTillagg = (data) => {
    return {
        type: GET_LOCAL_TILLAGG,
        data: data
    }
}
export const getLocalTillaggFrom = (data) => {
    return {
        type: GET_LOCAL_TILLAGGFORM,
        data
    }
} 

export const updateArtcile = (name, value) => {
    return {
        type: UPDATE_ARTICLE,
        name: name,
        value: value

    }
}

export const updateTillaggForm = (index, tillaggtyp, value) => {

    return {
        index: index,
        type: UPDATE_CHECKED,
        tillaggtype: tillaggtyp,
        value: value
    }

}
export const updateTillaggFormBanderoll = (index, tillaggtyp, value) => {

    return {
        index,
        type: UPDATE_CHECKED_BANDEROLL,
        tillaggtyp,
        value
    }

}


// WEBPACK FOOTER //
// ./src/Services/Tillagg/action.js